<template>
  <div>
    <div class="sort">
      <div class="content border">
        <div class="sort_pos">
          <button class="sort_pos_grid" @click="changeView('grid')" :class="{'active' : viewType=='grid'}">
            <i class="icon-grid"></i>
          </button>
          <button class="sort_pos_list" @click="changeView('list')" :class="{'active' : viewType=='list'}">
            <i class="icon-list"></i>
          </button>
        </div>
        <div class="sort_opts">
          <div class="sort_item">
            <div class="sort_label">
              Сортировка
              <select v-select2 class="sort_select" v-model="localSortType" @change="changeSort">
                <option :value="value" v-for="(name, value) in sortTypeVariants" :key="value"
                        :selected="localSortType==value" v-html="name"></option>
              </select>
            </div>
          </div>
          <div class="sort_item">
            <div class="sort_label">
              На странице
              <select v-select2 class="sort_select" v-model="onPage" @change="changeOnPage">
                <option :value="v" v-for="v in onPageVariants" :key="v" :selected="onPage==v">{{ v }}</option>
              </select>
            </div>
          </div>
          <div class="sort_item">
            <label class="sort_label">{{ count }} позиций</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'ProductListSort',
  props: ['count', 'sortType'],
  data() {
    return {
      viewType: 'grid',
      sortTypeVariants: {
        'popularity': 'Популярности',
        'sizes': 'Размерности',
        'articul': 'Артикулу',
        'code': 'Коду',
        'priceasc': 'Цене &uarr;',
        'pricedesc': 'Цене &darr;'
      },
      onPageVariants: [12, 24, 36],
      onPage: 12,
      localSortType: this.sortType
    }
  },
  created: function () {
    this.parseUri()
  },
  watch: {
    sortType(newVal) {
      this.localSortType = newVal;
    }
  },
  methods: {
    parseUri() {
      if (document.location.search) {
        const filterParams = JSON.parse(decodeURI(document.location.search.split('&')[0]).substr(1));

        if (filterParams['vt']) {
          this.viewType = filterParams['vt']
        }
        if (filterParams['op']) {
          this.onPage = filterParams['op']
        }
        if (filterParams['st']) {
          this.localSortType = filterParams['st']
        }
      }
    },
    setOnPage(onPage) {
      this.onPage = onPage
    },
    setSortType(sortType) {
      this.localSortType = sortType;
    },
    setViewType(viewType) {
      this.viewType = viewType
    },
    changeView(viewType) {
      this.viewType = viewType;
      this.$emit('change-view-type', this.viewType);
    },
    changeOnPage() {
      this.$emit('change-on-page', this.onPage);
    },
    changeSort() {
      this.$emit('change-sort', this.localSortType);
    }
  }
}
</script>

<style>
.sort_opts .select2.select2-container {
  margin-top: -5px !important;
}
</style>